import {flatMap, pipe} from '@yandex-delivery/utils'

import type {NddClaimProducts, Parcel} from 'src/shared/types'

import {fromNddProduct} from './from-ndd-product'

export function fromNddProducts(parcels: Parcel[], orderNumber?: string, isPaymentGoods = false): NddClaimProducts {
  return pipe(
    parcels,
    flatMap(function _fromNddProducts(parcel, parcelIndex) {
      const barcode = parcel.barcode || orderNumber

      return parcel.products.map((product, productIndex) => {
        return fromNddProduct(product, barcode, parcelIndex, productIndex, isPaymentGoods)
      })
    }),
  )
}
